import { Grid, Theme, WithStyles } from "@material-ui/core";
import ICommunityOwnership from "../types/ICommunityOwnership";
import * as React from "react";
import {
  loadCommunityConfigs, loadCommunityStatistics
} from "../../core/actions/communitiesActions";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography/Typography";
import BreadCrumb from "../../shared/components/BreadCrumb";
import store from "../../core/store";
import { isAdmin } from "../../core/auth/identityAuth";
import CommunityCard from "./CommunityCard";
import ICommunityConfig from "../types/ICommunityConfig";
import { ICommunityStatistic } from "../types/ICommunityStatistic";
import Alert from "../../shared/components/Alert";
import Loading from "../../shared/components/loading/Loading";

const styles = (theme: Theme) => ({
  cardContainer: {
    marginTop: theme.spacing.unit * 2
  }
});


interface IState {

}

interface IProps extends WithStyles<typeof styles> {
  communityOwnerships: ICommunityOwnership[]
  communityConfigs: ICommunityConfig[],
  communityStatistics: ICommunityStatistic[] | null,
  isLoading: boolean
}

class CommunityManagementHome extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {}
  }

  public componentDidMount() {
    store.dispatch(loadCommunityStatistics());
    this.loadCommunityConfigsIfNeeded();
  }

  public componentDidUpdate() {
    this.loadCommunityConfigsIfNeeded();
  }

  public loadCommunityConfigsIfNeeded() {
    if (isAdmin && this.props.communityOwnerships && this.props.communityOwnerships.length && this.props.communityConfigs === null) {
      const communityCodes = this.props.communityOwnerships.map(ownership => ownership.communityCode);
      store.dispatch(loadCommunityConfigs(communityCodes))
    }
  }

  public render() {
    const canViewCommunityOwnerships: boolean = isAdmin
      && this.props.communityOwnerships
      && !!this.props.communityOwnerships.length
      && this.props.communityConfigs
      && !!this.props.communityConfigs.length;

    const showPendingMembershipsAlert: boolean = canViewCommunityOwnerships && !!this.props.communityStatistics && !!this.props.communityStatistics.find(x => x.pendingMemberships !== 0);

    const titleAndBreadCrumbs =
      <>
        <Typography variant="title">Community management</Typography>
        <Typography color="textSecondary" gutterBottom>
          <BreadCrumb value="Console" to="/"/>
          Community management
        </Typography>
      </>;

    if (this.props.isLoading) {
      return (
        <>
          {titleAndBreadCrumbs}
          <Loading/>
        </>
      )
    }

    return <div>
      {titleAndBreadCrumbs}

      {showPendingMembershipsAlert && (
        <div style={{ marginTop: '24px', marginBottom: '24px' }}>
          <Alert
            severity='warning'
            title="There are memberships pending!"
          >
            <Typography color="inherit">
              Click on 'Manage' to view all pending memberships for a community.
            </Typography>
          </Alert>
        </div>
      )}

      {canViewCommunityOwnerships ?
        <Grid
          container
          spacing={16}
          className={this.props.classes.cardContainer}
          alignContent="stretch"
        >
          {this.props.communityConfigs.map(community => {
            return (
              <CommunityCard
                key={community.code}
                communityStatistic={this.getCommunityStatisticForCommunity(community)}
                community={community}/>
            );
          })
          }
        </Grid>
        :
        <Typography>You are not an admin of any community.</Typography>
      }
    </div>
  }

  public getCommunityStatisticForCommunity(community: ICommunityConfig): ICommunityStatistic | undefined {
    if (!this.props.communityStatistics) {
      return undefined;
    }
    return this.props.communityStatistics.find(stat => stat.communityCode === community.code);
  }
}

function mapStateToProps(state: any) {
  return {
    communityOwnerships: state.communitiesReducer.communityOwnerships,
    communityConfigs: state.communitiesReducer.communityConfigs,
    communityStatistics: state.communitiesReducer.communityStatistics,
    isLoading: state.communitiesReducer.communityOwnershipsLoading
      || state.communitiesReducer.communityConfigsLoading
      || state.communitiesReducer.communityStatisticsLoading
  };
}

// @ts-ignore
export default connect(mapStateToProps)(withStyles(styles)(CommunityManagementHome))




// WEBPACK FOOTER //
// ./src/modules/communities/components/CommunityManagementHome.tsx